import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';

import { useTranslation } from '../../../common/hooks/useTranslation';
import { NewDateRangePicker } from '../../../app/components/NewDateRangePicker';

export interface FiltersParams {
  dateFrom: Date | null;
  dateTo: Date | null;
  showSettled: boolean;
}

interface ContractEstimateItemFiltersProps {
  filters: FiltersParams;
  handleChangeFilters: (filters: Partial<FiltersParams>) => void;
}

export const ContractEstimateItemFilters: React.FC<
  ContractEstimateItemFiltersProps
> = props => {
  const { t, tk } = useTranslation('projectLng');
  return (
    <>
      <Row className="p-2">
        <Form.Group as={Row} controlId="monthFilter">
          <Form.Label column sm="2">
            {t(tk.contract.monthFilter)}
          </Form.Label>
          <Col>
            <div className="small-calendar">
              <NewDateRangePicker
                onChange={value => {
                  if (value) {
                    value = value as [Date | null, Date | null];
                    return props.handleChangeFilters({
                      dateFrom: value[0],
                      dateTo: value[1],
                    });
                  }

                  return props.handleChangeFilters({
                    dateFrom: null,
                    dateTo: null,
                  });
                }}
                value={
                  props.filters.dateFrom && props.filters.dateTo
                    ? [props.filters.dateFrom, props.filters.dateTo]
                    : null
                }
              />
            </div>
          </Col>
        </Form.Group>
      </Row>
      <Row className="p-2">
        <Form.Group as={Row} controlId="monthFilter">
          <Form.Label column sm="2">
            {t(tk.contract.showSettled)}
          </Form.Label>
          <Col>
            <Form.Check
              type="checkbox"
              className="pt-2"
              checked={props.filters.showSettled}
              onChange={e =>
                props.handleChangeFilters({ showSettled: e.target.checked })
              }
            />
          </Col>
        </Form.Group>
      </Row>
      <hr />
    </>
  );
};
